export var AddressCheckerStep;
(function (AddressCheckerStep) {
    AddressCheckerStep["START"] = "START";
    AddressCheckerStep["ERROR"] = "ERROR";
    AddressCheckerStep["ADDRESS_NOT_FOUND"] = "ADDRESS_NOT_FOUND";
    AddressCheckerStep["CHECKING_ADDRESS"] = "CHECKING_ADDRESS";
    AddressCheckerStep["SHOW_AVAILABLE_TECH"] = "SHOW_AVAILABLE_TECH";
    AddressCheckerStep["SHOW_UPCOMING_TECH"] = "SHOW_UPCOMING_TECH";
    AddressCheckerStep["ADDRESS_SUBMITTED"] = "ADDRESS_SUBMITTED";
    AddressCheckerStep["EMAIL_SUBMITTED"] = "EMAIL_SUBMITTED";
})(AddressCheckerStep || (AddressCheckerStep = {}));
